module.exports = __webpack_public_path__ + "static/media/pdf.75183d33.png";